import { useState } from 'react'

import { PktLink } from '..'

export default function Link() {
  const [count, setCount] = useState(1)
  return (
    <main className="page-main pkt-container">
      <h1>Link</h1>
      <button className="pkt-btn pkt-btn--secondary" onClick={() => setCount(count + 1)}>
        Endre lenke
      </button>
      <section className="component">
        <p>
          <PktLink href="https://www.oslo.kommune.no">Vanlig lenke {count}</PktLink>
        </p>
        <p>
          <PktLink external href="https://www.oslo.kommune.no">
            Ekstern lenke {count}
          </PktLink>
        </p>
        <p>
          <PktLink iconName="user" href="https://www.oslo.kommune.no" external>
            Lenke med ikon {count}
          </PktLink>
        </p>
        <p>
          <PktLink
            iconName="user"
            iconPosition="right"
            href="https://www.oslo.kommune.no"
            className="class"
            onClick={(e) => {
              e.preventDefault()
              console.log('Link clicked!', e)
            }}
          >
            Lenke med ikon til høyre {count}
          </PktLink>
        </p>
      </section>
    </main>
  )
}
